/**
 * Browser-safe workflow surface.
 *
 * Everything a client component needs — the types, the observed-state shapes,
 * the pure evaluator, and the catalog itself — and deliberately *not* the state
 * loader, which reads `@repo/database`. Re-exported from
 * `packages/core/src/client/index.ts`.
 */
export * from "./types";
export * from "./state";
export * from "./evaluate";
export * from "./catalog";
export * from "./run-like";
export * from "./spend";
export * from "./setup";
